document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {

  /* ── Menu mobile : fermer au clic ── */
  document.querySelectorAll('[data-close-menu-on-click]').forEach((link) => {
    link.addEventListener('click', () => {
      const d = link.closest('details');
      if (d) d.removeAttribute('open');
    });
  });

  /* ── Menu mobile : fermer au clic extérieur ── */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.mobile-menu[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ── Sticky header ── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Variant selector ── */
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      const price = selected.dataset.price;
      const available = selected.dataset.available === 'true';
      const priceEl = document.querySelector('[data-product-price]');
      const btnEl = document.querySelector('[data-add-to-cart]');
      if (priceEl && price) priceEl.textContent = price;
      if (btnEl) {
        btnEl.disabled = !available;
        btnEl.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      }
    });
  }

  /* ── Notification panier ── */
  const notification = document.getElementById('cart-notification');
  const notifText = document.getElementById('cart-notification-text');

  function showCartNotification(productTitle) {
    if (!notification) return;
    notifText.textContent = (productTitle || 'Produit') + ' ajouté au panier';
    notification.hidden = false;
    notification.classList.add('is-visible');
    clearTimeout(notification._timer);
    notification._timer = setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => { notification.hidden = true; }, 300);
    }, 3200);
  }

  /* ── Formulaire ajout panier ── */
  document.querySelectorAll('.product-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      try {
        const formData = new FormData(form);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        const data = await resp.json();
        const countResp = await fetch('/cart.js');
        const cart = await countResp.json();
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        showCartNotification(data.product_title || data.title);
      } catch (err) {
        console.error('Erreur ajout panier:', err);
        form.submit();
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      }
    });
  });

  /* ── Quantité produit ── */
  document.querySelectorAll('.quantity-input').forEach((input) => {
    input.addEventListener('change', () => {
      if (parseInt(input.value) < 1) input.value = 1;
    });
  });

  /* ── Smooth scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ── Galerie produit avec vignettes ── */
  const mediaItems = document.querySelectorAll('.product-media-item');
  const thumbs = document.querySelectorAll('.product-thumb');

  function activateMedia(index) {
    mediaItems.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
  }

  if (mediaItems.length > 0) {
    activateMedia(0);
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => activateMedia(i));
    });
  }

});
